/* eslint-disable max-lines */
/* eslint-disable id-length */
/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */
/* eslint-disable vars-on-top */

ACC.cartremoveitem = {
  productUnitPriceId: '#product-unit-price-',
  bindAll: function() {
    this.bindCartRemoveProduct();
  },
  deleteProductFromCartAPI: function($deleteEle) {
    var entryNum = $deleteEle.attr('id').split('_')[1];
    var prodid = $deleteEle.attr('data-prodctvindex');
    var ballonQuantity = $('.quantity-balloon').text();
    var updateBallonQuantity = ballonQuantity - 1;

    $('.quantity-balloon').text(updateBallonQuantity);

    var $form = $('#updateCartForm' + entryNum);
    var initialCartQuantity = $form.find('input[name=initialQuantity]');
    var cartQuantity = $form.find('input[name=quantity]');
    var productCode = $form.find('input[name=productCode]').val();


    cartQuantity.val(0);
    initialCartQuantity.val(0);
    /* eslint-disable no-undef */


    ACC.track.trackRemoveFromCart(productCode, initialCartQuantity, cartQuantity.val());
    ACC.cartremoveitem.trackDeleteGoogleAnalytics(prodid);

    /* eslint-disable no-ternary */
    var method = $form.attr('method') ? $form.attr('method').toUpperCase() : 'GET';

    $.ajax({
      url: $form.attr('action'),
      data: $form.serialize(),
      type: method,
      success: function() {
        window.location.reload(true);
      },
      error: function() {
        $('.ph-no-hover').html('');
      }
    });
  },
  bindCartRemoveProduct: function() {
    /* eslint-disable max-statements */
    $('.submitRemoveProduct').on('click', function(event) {
      event.preventDefault();
      $(this).next().next().find('.wait-message').show();
      $(this).next().next().find('.loader').show();
      $(this).next().next().find('.hide-anchor').css('margin-top', '-27px');
      $('.hide-drop-down').show();
      $('.qty').attr('readonly', 'readonly');
      $('.hide-anchor').show();
      $('.pe_tabbar .last a').css('pointer-events', 'none');
      $('.pe_calendar').css('pointer-events', 'none');
      $('.rp-select').css('pointer-events', 'none');
      $('.calender-hide').show();
      $('.submitRemoveProduct').css('pointer-events', 'none');
      ACC.common.requestPopup();
      ACC.cartremoveitem.deleteProductFromCartAPI($(this));
    });

    /* Commenting as below code is not required due to removal of popup confirmation
    $(document).on('click', '.ph-deal-product-remove-yes', function() {
      var deleteBtnId = $(this).attr('data-delete-btn-id');

      $.colorbox.remove();
      ACC.common.requestPopup();
      ACC.cartremoveitem.deleteProductFromCartAPI($('#' + deleteBtnId));
    });

    $(document).on('click', '.ph-deal-product-remove-no', function() {
      $.colorbox.remove();
    });
    */

    $('.updateQuantityProduct').on('click', function(event) {
      event.preventDefault();

      var prodid = $(this).attr('id').split('_');
      var $grid = $('#grid_' + prodid[1]);

      $grid.addClass('cboxGrid');

      var strSubEntries = $grid.data('sub-entries');
      var arrSubEntries = strSubEntries.split(',');
      var firstVariantCode = arrSubEntries[0].split(':')[0];
      /* eslint-disable no-new-object */
      var mapCodeQuantity = new Object();
      /* eslint-enable no-new-object */

      for (var i = 0; i < arrSubEntries.length; i = i + 1) {
        var arrValue = arrSubEntries[i].split(':');

        mapCodeQuantity[arrValue[0]] = arrValue[1];
      }

      var method = 'GET';

      $.ajax({
        url: ACC.config.encodedContextPath + '/cart/getProductVariantMatrix',
        data: {
          productCode: firstVariantCode
        },
        type: method,
        success: function(data) {
          $grid.html(data);

          var $gridContainer = $grid.find('.product-grid-container');
          var numGrids = $gridContainer.length;

          /* eslint-disable no-shadow */
          for (var i = 0; i < numGrids; i = i + 1) {
            ACC.cartremoveitem.getProductQuantity($gridContainer.eq(i), mapCodeQuantity);
          }

          $.colorbox({
            /* eslint-disable xss/no-mixed-html */
            html: $grid.clone(true).show(),
            scroll: true,
            /* Width:     "80%",
               Height:    "80%", */
            onCleanup: function() {
              // Remove the cloned grid
              $grid.empty();

              strSubEntries = '';
              $.each(mapCodeQuantity, function(key, value) {
                /* eslint-disable no-undefined */
                if (value !== undefined) {
                  strSubEntries = strSubEntries + key + ':' + value + ',';
                }
              });

              $grid.data('sub-entries', strSubEntries);
            }
          });

          ACC.cartremoveitem.coreTableActions(prodid[1], mapCodeQuantity);
        },
        error: function() {
          $('.ph-no-hover').html('');
        }

      });
      /* eslint-enable xss/no-mixed-html */
      // Grid.show();
    });

    $('.qty').on('keypress', function(e) {
      var $input = $(this);

      if ((e.keyCode || e.which) === 13) {
        // Enter was hit
        e.preventDefault();
        $input.blur();
      }
    });

    $('.qty').on('blur', function() {
      var entryNum = $(this).parent().find('input[name=entryNumber]').val();

      var $form = $('#updateCartForm' + entryNum);
      var initialCartQuantity = $form.find('input[name=initialQuantity]').val();
      var newCartQuantity = $form.find('input[name=quantity]').val();
      var productCode = $form.find('input[name=productCode]').val();

      if (initialCartQuantity !== newCartQuantity) {
        ACC.track.trackUpdateCart(productCode, initialCartQuantity, newCartQuantity);

        var method = $form.attr('method') ? $form.attr('method').toUpperCase() : 'GET';

        /* eslint-enable no-ternary */
        $.ajax({
          url: $form.attr('action'),
          data: $form.serialize(),
          type: method,
          success: function() {
            window.location.reload(true);
          },
          error: function() {
            $('.ph-label').val('');
          }

        });
      }
    });
  },
  gaEventForDealRemoved: function(dealNumber) {
    ACC.googleanalytics.gaEventsForLinks({
      url: window.location.protocol + '//' + window.location.host + ACC.config.encodedContextPath + '/cart',
      description: 'Vistex deal gets removed',
      trigger: 'dealcart.removeproduct.click',
      value: dealNumber,
      compname: 'dealcartProductRemoval'
    });
  },
  getProductObjectGoogleAnalytics: function(index) {
    var gaproductclass = '.ph-prodindex-' + index,
        priceVal = '',
        locale = window.eddlContext.locale.code,
        entryNum = $(gaproductclass).data('entrynumber'),
        isFreeMarketingProduct = $('.isFreeMarketing_' + entryNum).val();

    if (window.eddlContext.locale.currency === 'THB') {
      priceVal = $(gaproductclass).find('.ph-qty').find('.unit').html().replace(/,/g, '');
    } else if (isFreeMarketingProduct) {
      priceVal = '0';
    } else {
      priceVal = $(gaproductclass).find('.ph-qty').find('.unit').html().replace(/,(?=[^,]*$)/, '.');
    }

    return {
      id: $(gaproductclass).attr('data-ctv'),
      locale: locale,
      quantity: parseInt($(gaproductclass).find('.qty').text(), 10),
      price: parseFloat(priceVal.replace(/[^\d.-]/g, ''))
    };
  },

  gaAddtocartpdp: function(prodid, productCodeValue, deltaQuantity) {
    var priceVal = '',
        isFreeMarketingProduct = $('.isFreeMarketing_' + prodid).val();

    if (window.eddlContext.locale.currency === 'THB') {
      priceVal = $(ACC.cartremoveitem.productUnitPriceId + prodid).find('.unit').html().replace(/,/g, '');
    } else if (isFreeMarketingProduct) {
      priceVal = '0';
    } else {
      priceVal = $(ACC.cartremoveitem.productUnitPriceId + prodid).find('.unit').html().replace(/,(?=[^,]*$)/, '.');
    }

    var eddlAction = {
      trigger: 'ecommerce.cart.add',
      event: 'ecommerceEvent',
      ecommerce: {
        currencyCode: window.eddlContext.locale.currency,
        add: {
          actionField: {
            list: 'cartItems'
          },
          products: [
            {
              id: productCodeValue,
              locale: window.eddlContext.locale.code,
              quantity: deltaQuantity,
              price: parseFloat(priceVal.replace(/[^\d.-]/g, ''))
            }
          ]
        }
      }
    };

    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },
  garemoveCart: function(prodid, productCodeValue, deltaQuantity) {
    var priceVal = '',
        productItemUnitPrice = $(ACC.cartremoveitem.productUnitPriceId + prodid).find('.unit');

    if (window.eddlContext.locale.currency === 'THB') {
      // eslint-disable-next-line no-ternary
      priceVal = productItemUnitPrice.length > 0 ? productItemUnitPrice.html().replace(/,/g, '') : '0';
    } else {
      // eslint-disable-next-line no-ternary
      priceVal = productItemUnitPrice.length > 0 ? productItemUnitPrice.html().replace(/,(?=[^,]*$)/, '.') : '0';
    }

    var eddlAction = {
      trigger: 'ecommerce.cart.remove',
      event: 'ecommerceEvent',
      ecommerce: {
        currencyCode: window.eddlContext.locale.currency,
        remove: {
          actionField: {
            list: 'cartItems'
          },
          products: [
            {
              id: productCodeValue,
              locale: window.eddlContext.locale.code,
              quantity: deltaQuantity,
              price: parseFloat(priceVal.replace(/[^\d.-]/g, ''))
            }
          ]
        }
      }
    };

    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },

  trackClearCartGoogleAnalytics: function(prodindex, totalCartItems) {
    var currencyCode = window.eddlContext.locale.currency,
        eddlAction = {},
        product = {},
        productsArray = [],
        index = 0;

    for (index = prodindex; index < totalCartItems; index = index + 1) {
      product = ACC.cartremoveitem.getProductObjectGoogleAnalytics(index);
      productsArray.push(product);
    }

    eddlAction = ACC.cartremoveitem.eddlActionObj(currencyCode, productsArray);
    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },

  trackDeleteGoogleAnalytics: function(prodindex) {
    var currencyCode = window.eddlContext.locale.currency,
        eddlAction = {},
        product = {},
        productsArray = [];

    product = ACC.cartremoveitem.getProductObjectGoogleAnalytics(prodindex);
    productsArray.push(product);
    eddlAction = ACC.cartremoveitem.eddlActionObj(currencyCode, productsArray);
    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },


  eddlActionObj: function(currencyCode, productsArray) {
    return {
      trigger: 'ecommerce.cart.remove',
      event: 'ecommerceEvent',
      ecommerce: {
        currencyCode: currencyCode,
        remove: {
          products: productsArray
        }
      }
    };
  },


  getProductQuantity: function(gridContainer, mapData) {
    var skus = jQuery.map(function(x) {
      return gridContainer.find('input[type=\'hidden\'].sku')(x);
    }, function(o) {
      return o.value;
    });
    var quantities = jQuery.map(function(x) {
      return gridContainer.find('input[type=\'textbox\'].sku-quantity')(x);
    }, function(o) {
      return o;
    });

    var totalPrice = 0.0,
        totalQuantity = 0.0;

    $.each(skus, function(index, skuId) {
      var quantity = mapData[skuId];

      if (quantity !== undefined) {
        /* eslint-enable no-undefined */
        quantities[index].value = quantity;
        totalQuantity = totalQuantity + parseFloat(quantity);

        /* eslint-disable radix */
        var indexPattern = '[0-9]+';
        var currentIndex = parseInt(quantities[index].id.match(indexPattern));

        var currentPrice = $('input[id=\'productPrice[' + currentIndex + ']\']').val();

        /* eslint-disable no-mixed-operators */
        totalPrice = totalPrice + parseFloat(currentPrice) * parseInt(quantity);
      }
    });

    var avgPriceValue = 0.0,
        subTotalValue = 0.0;

    gridContainer.parent().find('#quantity').html(totalQuantity);
    gridContainer.parent().find('#avgPrice').html(avgPriceValue);
    gridContainer.parent().find('#subtotal').html(subTotalValue);

    var $inputQuantityValue = gridContainer.parent().find('#quantityValue');
    var $inputAvgPriceValue = gridContainer.parent().find('#avgPriceValue');
    var $inputSubtotalValue = gridContainer.parent().find('#subtotalValue');

    $inputQuantityValue.val(totalQuantity);
    $inputAvgPriceValue.val(Number(totalPrice / totalQuantity).toFixed(2));
    $inputSubtotalValue.val(Number(totalPrice).toFixed(2));
  },

  coreTableActions: function(productCode, mapCodeQuantity) {
    var skuQuantityClass = '.sku-quantity';

    var quantityBefore = 0;
    var quantityAfter = 0;

    var $grid = $('#grid_' + productCode);

    $grid.on('click', skuQuantityClass, function() {
      $(this).select();
    });

    $grid.on('focusin', skuQuantityClass, function() {
      quantityBefore = jQuery.trim(this.value);

      if (quantityBefore === '') {
        quantityBefore = 0;
        this.value = 0;
      }
    });

    $grid.on('focusout', skuQuantityClass, function() {
      var indexPattern = '[0-9]+';
      var currentIndex = parseInt($(this).attr('id').match(indexPattern));
      var $gridGroup = $(this).parents('.orderForm_grid_group');
      var $closestQuantityValue = $gridGroup.find('#quantityValue');
      var $closestAvgPriceValue = $gridGroup.find('#avgPriceValue');
      var $closestSubtotalValue = $gridGroup.find('#subtotalValue');

      var currentQuantityValue = $closestQuantityValue.val();
      var currentSubtotalValue = $closestSubtotalValue.val();

      var currentPrice = $('input[id=\'productPrice[' + currentIndex + ']\']').val();
      var variantCode = $('input[id=\'cartEntries[' + currentIndex + '].sku\']').val();

      quantityAfter = jQuery.trim(this.value);

      if (isNaN(jQuery.trim(this.value))) {
        this.value = 0;
      }

      if (quantityAfter === '') {
        quantityAfter = 0;
        this.value = 0;
      }

      if (quantityBefore === 0) {
        $closestQuantityValue.val(parseInt(currentQuantityValue) + parseInt(quantityAfter));
        $closestSubtotalValue.val(parseFloat(currentSubtotalValue) + parseFloat(currentPrice) * parseInt(quantityAfter));
      } else {
        $closestQuantityValue.val(parseInt(currentQuantityValue) + (parseInt(quantityAfter) - parseInt(quantityBefore)));
        $closestSubtotalValue.val(parseFloat(currentSubtotalValue) + parseFloat(currentPrice) * (parseInt(quantityAfter) - parseInt(quantityBefore)));
      }

      /* eslint-enable no-mixed-operators */
      if (parseInt($closestQuantityValue.val()) > 0) {
        $closestAvgPriceValue.val(parseFloat($closestSubtotalValue.val()) / parseInt($closestQuantityValue.val()));
      } else {
        $closestAvgPriceValue.val(0);
      }

      /* eslint-enable radix */
      $closestQuantityValue.parent().find('#quantity').html($closestQuantityValue.val());
      $closestAvgPriceValue.parent().find('#avgPrice').html(ACC.productorderform.formatTotalsCurrency($closestAvgPriceValue.val()));
      $closestSubtotalValue.parent().find('#subtotal').html(ACC.productorderform.formatTotalsCurrency($closestSubtotalValue.val()));

      if (quantityBefore !== quantityAfter) {
        var method = 'POST';

        $.ajax({
          url: ACC.config.encodedContextPath + '/cart/update',
          data: {
            productCode: variantCode,
            quantity: quantityAfter,
            entryNumber: -1
          },
          type: method,
          success: function(data) {
            ACC.cartremoveitem.refreshCartData(data, -1, productCode, null);
            mapCodeQuantity[variantCode] = quantityAfter;
          },
          error: function() {
            $('.ph-remove-cross').val('');
          }

        });
      }
    });
  },
  /* eslint-disable complexity */
  /* eslint-disable no-redeclare */
  /* eslint-disable mysticatea/block-scoped-var */
  refreshCartData: function(cartData, entryNum, productCode, quantity) { // NOSONAR
    // If cart is empty, we need to reload the whole page
    /* eslint-enable complexity */
    /* eslint-enable max-statements */
    if (cartData.entries.length === 0) { // NOSONAR
      location.reload();
    } else {
      /* eslint-disable init-declarations */
      var $form;
      var removeItem = false;

      /* eslint-enable init-declarations */
      if (entryNum === -1) { // NOSONAR
        // Grouped item
        var $editLink = $('#QuantityProduct_' + productCode);

        $form = $editLink.parent();

        var quantity = 0;
        var entryPrice = 0;

        /* eslint-disable block-scoped-var */
        for (var i = 0; i < cartData.entries.length; i = i + 1) { // NOSONAR
          var entryVar = cartData.entries[i];

          if (entryVar.product.code === productCode) {
            /* eslint-disable no-param-reassign */
            quantity = entryVar.quantity;
            entryPrice = entryVar.basePrice;

            /* eslint-enable no-param-reassign */
            break;
          }
        }

        if (quantity === 0) {
          removeItem = true;
          $form.parent().parent().remove();
        } else {
          $form.find('.qty').html(quantity);
          $form.parent().parent().find('.total').html(entryPrice.formattedValue);
        }
      } else {
        // Ungrouped item
        $form = $('#updateCartForm' + entryNum);

        if (quantity === 0) {
          removeItem = true;
          $form.parent().parent().remove();
        } else {
          for (var i = 0; i < cartData.entries.length; i = i + 1) {
            var entry = cartData.entries[i];

            /* eslint-disable max-depth */
            if (entry.entryNumber === entryNum) {
              $form.find('input[name=quantity]').val(entry.quantity);

              if (entry.basePrice !== null && entry.basePrice.value !== null && entry.basePrice.value !== 0) {
                $form.parent().parent().find('.total').html(entry.basePrice.formattedValue);
                $form.parent().parent().find('.unit').html(entry.unitPrice.formattedValue);
              }

              /* eslint-disable no-undefined */
              if (entry.scheduleLines !== null && entry.scheduleLines !== undefined) {
                var formattedSchedLine = '';

                for (var j = 0; j < entry.scheduleLines.length; j = j + 1) {
                  var schedline = entry.scheduleLines[j];
                  /* eslint-disable xss/no-mixed-html */
                  var innerSpans = '<span class=\'light\'>' + schedline.formattedValue + '</span>';

                  formattedSchedLine = formattedSchedLine + innerSpans;
                }

                $form.parent().parent().find('.third').find('#schedLineAjax').html('<span class=\'light\'>' + formattedSchedLine + '</span>');
              }

              if (entry.entryMessages !== null && entry.entryMessages !== undefined) {
                var messages = '';
                /* eslint-enable no-undefined */

                for (var k = 0; k < entry.entryMessages.length; k = k + 1) {
                  var message = entry.entryMessages[k];
                  var crossSymbol = '';

                  /* eslint-enable no-undef */
                  /* eslint-enable block-scoped-var */
                  if (message.messageClass !== 'error') {
                    crossSymbol = '<i class=\'icon closeRound\'></i>';
                    /* eslint-enable max-depth */
                  }

                  var htmlData = '<span class=\'error-message ' +
                    message.messageClass +
                    '\'>' +
                    '<i class=\'icon error\'></i>' +
                    crossSymbol +
                    '<span>' +
                    message.statusMessage + '</span></span>';

                  messages = messages + htmlData;
                }

                $form.parent().parent().find('#sapMessages').html(messages);
              }/* eslint-enable xss/no-mixed-html */
            }
          }
        }
      }

      // Remove item, need to update other items' entry numbers
      if (removeItem === true) { // NOSONAR
        $('.cartItem').each(function() {
          $form = $(this).find('.quantity').children().first();

          var productCode = $form.find('input[name=productCode]').val();

          for (var i = 0; i < cartData.entries.length; i = i + 1) { // NOSONAR
            var entryNum = cartData.entries[i];

            /* eslint-enable no-shadow*/
            if (entryNum.product.code === productCode) {
              $form.find('input[name=entryNumber]').val(entryNum.entryNumber);

              break;
            }
          }
        });
      }

      // Refresh mini cart
      ACC.minicart.refreshMiniCartCount();
      PHI.checkout.displayErrors();

      $('#orderTotals').next().remove();
      $('#orderTotals').remove();
      $('#ajaxCart').html($('#cartTotalsTemplate').tmpl({
        data: cartData
      }));
    }
  }
/* eslint-enable no-redeclare */
/* eslint-enable mysticatea/block-scoped-var */
};


$(document).ready(function() {
  var updatedQuantity = '';

  ACC.cartremoveitem.bindAll();

  $(document).on('click', '#ph-clearcart-confirm', function() {
    var $productCtn = $('.ph-cart__ctn'),
        totalCartItems = $productCtn.length;

    ACC.cartremoveitem.trackClearCartGoogleAnalytics(0, totalCartItems);
  });

  $(document).on('keyup blur', '.ph-Eqpopup_qty', function() {
    updatedQuantity = $(this).val();
  });

  $(document).on('click', '.ph-qtydet__block__action--save', function() {
    var prodid = $(this).attr('id').split('_')[1],
        currentQuantity = $('.ajaxQty_' + prodid).val(),
        productCodeValue = $(this).attr('data-ctv'),
        deltaQuantity = '',
        modifiedQuantity = parseInt(updatedQuantity, 10);

    window.eddlEvents = window.eddlEvents || [];

    if ((currentQuantity > modifiedQuantity) || (modifiedQuantity === '0')) {
      deltaQuantity = currentQuantity - modifiedQuantity;
      ACC.cartremoveitem.garemoveCart(prodid, productCodeValue, deltaQuantity);
    } else if (modifiedQuantity > currentQuantity) {
      deltaQuantity = modifiedQuantity - currentQuantity;
    }

    if (currentQuantity !== modifiedQuantity && parseInt(modifiedQuantity, 10) > 0 && currentQuantity < modifiedQuantity) {
      ACC.cartremoveitem.gaAddtocartpdp(prodid, productCodeValue, deltaQuantity);
    }
  });

  if ($('.cartzoomprod').length > 0) {
    $('.ph-zoomMsginCart').show();
  }

  $(document).on('click', '.ph-cartentry_groupheader', function(evt) {
    var groupcode = $(this).attr('data-groupcode');

    if (!$(evt.target).hasClass('ph-link')) {
      $(this).find('.ph-groupedentry-collapse').toggleClass('ph-icon-arrow-down ph-icon-arrow-up');
      $('#cartGroupItems' + groupcode).toggleClass('hidden');
    }
  });
  $(document).on('click', '.ph-groupedentry-delete a', function() {
    var dealNumber = $(this).parents('.ph-cartentry_groupheader').attr('data-groupcode');

    ACC.cartremoveitem.gaEventForDealRemoved(dealNumber);
    $('.ph-popup_overlay').show();
    $.ajax({
      url: ACC.config.encodedContextPath + '/cart/removeDeal?dealNumber=' + dealNumber,
      type: 'GET',
      success: function() {
        window.location.reload();
      }
    });
  });
});
/* eslint-enable vars-on-top */
/* eslint-enable id-length */
/* eslint-enable max-lines */
/* eslint-enable no-inline-comments */
/* eslint-enable line-comment-position */
